var map = {
	"./account-active.svg": 16572,
	"./account.svg": 49185,
	"./affiliate-active.svg": 69596,
	"./affiliate.svg": 10209,
	"./announcement.svg": 74961,
	"./casino-active.svg": 16284,
	"./casino.svg": 16545,
	"./chevron.svg": 66661,
	"./menu-active.svg": 6620,
	"./menu.svg": 19361,
	"./redeem.svg": 29328,
	"./search.svg": 4880,
	"./vip-active.svg": 8496,
	"./vip.svg": 78045
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 82608;